module.exports = __webpack_public_path__ + "r-v3/img/clone_mode_le_11_22_05_off.f36ddbee.svg";